module.exports = __webpack_public_path__ + "static/HDBR-Cotidiano-2-6a62fbb36c20806b107f3f4120bcd82b.jpg";